import { DateTime } from 'luxon'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

interface ProviderDeadlineListItemProps {
  deadline: {
    time: string,
    title: string,
  },
}

const ProviderDeadlineListItem = (props: ProviderDeadlineListItemProps) => {
  const { deadline } = props

  const { time, title: serviceTitle } = deadline
  const formattedTime = DateTime.fromFormat(time, 'HH:mm').toFormat('h:mm a')

  return (
    <DashboardModuleListItem title={serviceTitle}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {formattedTime}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default ProviderDeadlineListItem
